// ops地图
export default [{ // ops地图
  path: '/opsMap',
  name: 'opsMap',
  component: resolve => require(['@/views/opsMap/opsMap.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // ops地图
  path: '/opsMapDetails',
  name: 'opsMapDetails',
  component: resolve => require(['@/views/opsMap/opsMapDetails.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/opsMap/opsMap.js